import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  PlusIcon,
  UserGroupIcon,
  ChartBarIcon,
  FunnelIcon,
  MagnifyingGlassIcon,
  EyeIcon,
  PencilIcon,
  ClockIcon,
  CheckCircleIcon,
  ArrowTrendingUpIcon,
} from '@heroicons/react/24/outline';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const ProjectView = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortBy, setSortBy] = useState('dueDate');

  // Projects data
  const projects = [
    {
      id: 1,
      name: "Healthcare Compliance",
      description: "Comprehensive healthcare compliance and regulatory adherence project covering all mandatory health assessments and safety protocols.",
      tasksCount: 12,
      completedTasks: 5,
      progress: 41.7,
      dueDate: "2025-08-15",
      status: "On Track",
      priority: "High",
      teamMembers: [
        { id: 1, name: "Dr. Meera Gupta", role: "Project Lead", avatar: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop&crop=face" },
        { id: 2, name: "Sarah Johnson", role: "Compliance Officer", avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b1e1?w=150&h=150&fit=crop&crop=face" },
        { id: 3, name: "Michael Chen", role: "Safety Coordinator", avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face" },
        { id: 4, name: "Lisa Rodriguez", role: "Documentation Specialist", avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face" },
        { id: 5, name: "David Kim", role: "Quality Analyst", avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face" },
      ],
      recentActivity: "Updated safety protocols documentation",
      lastUpdated: "2 hours ago",
      budget: 85000,
      spent: 32000,
      category: "Compliance",
      department: "Medical",
    },
    {
      id: 2,
      name: "Protocol Updates",
      description: "Systematic review and implementation of updated medical treatment protocols across all departments and specialties.",
      tasksCount: 18,
      completedTasks: 12,
      progress: 66.7,
      dueDate: "2025-08-30",
      status: "On Track",
      priority: "High",
      teamMembers: [
        { id: 1, name: "Dr. James Wilson", role: "Medical Director", avatar: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop&crop=face" },
        { id: 2, name: "Dr. Patricia Lee", role: "Clinical Lead", avatar: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop&crop=face" },
        { id: 3, name: "Emily Davis", role: "Protocol Specialist", avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b1e1?w=150&h=150&fit=crop&crop=face" },
        { id: 4, name: "Robert Garcia", role: "Training Coordinator", avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face" },
      ],
      recentActivity: "Completed cardiology protocol review",
      lastUpdated: "1 day ago",
      budget: 120000,
      spent: 75000,
      category: "Medical",
      department: "Clinical",
    },
    {
      id: 3,
      name: "Quality Management",
      description: "Comprehensive quality management system implementation to enhance patient care standards and operational excellence.",
      tasksCount: 22,
      completedTasks: 18,
      progress: 81.8,
      dueDate: "2025-09-15",
      status: "Ahead",
      priority: "Medium",
      teamMembers: [
        { id: 1, name: "Angela Martinez", role: "Quality Director", avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face" },
        { id: 2, name: "Thomas Anderson", role: "Quality Analyst", avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face" },
        { id: 3, name: "Jennifer Taylor", role: "Process Improvement", avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b1e1?w=150&h=150&fit=crop&crop=face" },
        { id: 4, name: "Mark Thompson", role: "Data Analyst", avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face" },
        { id: 5, name: "Rachel Green", role: "Quality Coordinator", avatar: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop&crop=face" },
        { id: 6, name: "Kevin Brown", role: "Audit Specialist", avatar: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop&crop=face" },
      ],
      recentActivity: "Submitted quarterly quality report",
      lastUpdated: "3 hours ago",
      budget: 200000,
      spent: 145000,
      category: "Quality",
      department: "Quality Assurance",
    },
    {
      id: 4,
      name: "Facilities Management",
      description: "Infrastructure maintenance and facility optimization project to ensure safe and efficient healthcare delivery environment.",
      tasksCount: 8,
      completedTasks: 3,
      progress: 37.5,
      dueDate: "2025-07-28",
      status: "At Risk",
      priority: "High",
      teamMembers: [
        { id: 1, name: "Frank Miller", role: "Facilities Manager", avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face" },
        { id: 2, name: "Susan Clark", role: "Maintenance Coordinator", avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face" },
        { id: 3, name: "John White", role: "Equipment Specialist", avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face" },
        { id: 4, name: "Maria Lopez", role: "Safety Inspector", avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b1e1?w=150&h=150&fit=crop&crop=face" },
      ],
      recentActivity: "Scheduled equipment maintenance review",
      lastUpdated: "5 hours ago",
      budget: 150000,
      spent: 95000,
      category: "Operations",
      department: "Facilities",
    },
    {
      id: 5,
      name: "Patient Experience",
      description: "Patient satisfaction improvement initiative focused on enhancing care delivery and patient communication processes.",
      tasksCount: 15,
      completedTasks: 15,
      progress: 100,
      dueDate: "2025-07-25",
      status: "Completed",
      priority: "Medium",
      teamMembers: [
        { id: 1, name: "Dr. Caroline Smith", role: "Patient Experience Director", avatar: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop&crop=face" },
        { id: 2, name: "James Wilson", role: "Patient Advocate", avatar: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop&crop=face" },
        { id: 3, name: "Linda Johnson", role: "Survey Coordinator", avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b1e1?w=150&h=150&fit=crop&crop=face" },
      ],
      recentActivity: "Project completed successfully",
      lastUpdated: "1 week ago",
      budget: 75000,
      spent: 72000,
      category: "Patient Care",
      department: "Patient Services",
    },
    {
      id: 6,
      name: "Staff Development",
      description: "Comprehensive staff training and professional development program to enhance skills and competencies across all departments.",
      tasksCount: 25,
      completedTasks: 8,
      progress: 32,
      dueDate: "2025-09-30",
      status: "On Track",
      priority: "Medium",
      teamMembers: [
        { id: 1, name: "Dr. Richard Davis", role: "Training Director", avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face" },
        { id: 2, name: "Amanda Foster", role: "Learning Coordinator", avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face" },
        { id: 3, name: "Christopher Lee", role: "Skills Assessment", avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face" },
        { id: 4, name: "Michelle Garcia", role: "Development Specialist", avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b1e1?w=150&h=150&fit=crop&crop=face" },
      ],
      recentActivity: "Launched new e-learning platform",
      lastUpdated: "2 days ago",
      budget: 180000,
      spent: 58000,
      category: "Training",
      department: "Human Resources",
    },
  ];

  // Filter and sort projects
  const filteredProjects = projects
    .filter(project => {
      const matchesStatus = statusFilter === 'all' || project.status.toLowerCase().replace(' ', '') === statusFilter;
      const matchesSearch = project.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        project.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
        project.category.toLowerCase().includes(searchQuery.toLowerCase());
      return matchesStatus && matchesSearch;
    })
    .sort((a, b) => {
      switch (sortBy) {
        case 'dueDate':
          return new Date(a.dueDate) - new Date(b.dueDate);
        case 'progress':
          return b.progress - a.progress;
        case 'name':
          return a.name.localeCompare(b.name);
        case 'priority':
          const priorityOrder = { 'High': 3, 'Medium': 2, 'Low': 1 };
          return priorityOrder[b.priority] - priorityOrder[a.priority];
        default:
          return 0;
      }
    });

  // Statistics
  const stats = {
    total: projects.length,
    active: projects.filter(p => p.status !== 'Completed').length,
    completed: projects.filter(p => p.status === 'Completed').length,
    atRisk: projects.filter(p => p.status === 'At Risk').length,
    totalTasks: projects.reduce((sum, p) => sum + p.tasksCount, 0),
    completedTasks: projects.reduce((sum, p) => sum + p.completedTasks, 0),
    totalBudget: projects.reduce((sum, p) => sum + p.budget, 0),
    totalSpent: projects.reduce((sum, p) => sum + p.spent, 0),
  };

  // Helper functions
  const getStatusColor = (status) => {
    switch (status) {
      case 'On Track': return 'text-green-600 bg-green-50 border-green-200';
      case 'Ahead': return 'text-blue-600 bg-blue-50 border-blue-200';
      case 'At Risk': return 'text-red-600 bg-red-50 border-red-200';
      case 'Delayed': return 'text-orange-600 bg-orange-50 border-orange-200';
      case 'Completed': return 'text-gray-600 bg-gray-50 border-gray-200';
      default: return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'High': return 'text-red-600 bg-red-50 border-red-200';
      case 'Medium': return 'text-yellow-600 bg-yellow-50 border-yellow-200';
      case 'Low': return 'text-green-600 bg-green-50 border-green-200';
      default: return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
    }).format(amount);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Page Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Projects</h1>
              <p className="text-gray-600 mt-1">
                Manage and track all project progress and deliverables
              </p>
            </div>
            <Link
              to="/projects/new"
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
            >
              <PlusIcon className="h-4 w-4" />
              <span>New Project</span>
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Statistics Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow-sm p-6 border">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total Projects</p>
                <p className="text-2xl font-bold text-gray-900">{stats.total}</p>
              </div>
              <ChartBarIcon className="h-8 w-8 text-blue-600" />
            </div>
            <div className="mt-2 flex items-center text-sm">
              <span className="text-green-600 flex items-center">
                <ArrowTrendingUpIcon className="h-4 w-4 mr-1" />
                12% from last month
              </span>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Active Projects</p>
                <p className="text-2xl font-bold text-gray-900">{stats.active}</p>
              </div>
              <ClockIcon className="h-8 w-8 text-yellow-600" />
            </div>
            <div className="mt-2 flex items-center text-sm">
              <span className="text-gray-600">
                {stats.atRisk} at risk
              </span>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Tasks Progress</p>
                <p className="text-2xl font-bold text-gray-900">
                  {((stats.completedTasks / stats.totalTasks) * 100).toFixed(0)}%
                </p>
              </div>
              <CheckCircleIcon className="h-8 w-8 text-green-600" />
            </div>
            <div className="mt-2 flex items-center text-sm">
              <span className="text-gray-600">
                {stats.completedTasks} of {stats.totalTasks} tasks
              </span>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Budget Utilization</p>
                <p className="text-2xl font-bold text-gray-900">
                  {((stats.totalSpent / stats.totalBudget) * 100).toFixed(0)}%
                </p>
              </div>
              <ChartBarIcon className="h-8 w-8 text-purple-600" />
            </div>
            <div className="mt-2 flex items-center text-sm">
              <span className="text-gray-600">
                {formatCurrency(stats.totalSpent)} of {formatCurrency(stats.totalBudget)}
              </span>
            </div>
          </div>
        </div>

        {/* Filters and Search */}
        <div className="bg-white rounded-lg shadow-sm border mb-6">
          <div className="p-6 border-b">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
              <div className="flex flex-col sm:flex-row sm:items-center space-y-4 sm:space-y-0 sm:space-x-4">
                {/* Search */}
                <div className="relative">
                  <MagnifyingGlassIcon className="h-5 w-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Search projects..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-64"
                  />
                </div>

                {/* Status Filter */}
                <div className="relative">
                  <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="appearance-none bg-white border border-gray-300 rounded-lg px-4 py-2 pr-8 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="all">All Status</option>
                    <option value="ontrack">On Track</option>
                    <option value="ahead">Ahead</option>
                    <option value="atrisk">At Risk</option>
                    <option value="delayed">Delayed</option>
                    <option value="completed">Completed</option>
                  </select>
                  <FunnelIcon className="h-4 w-4 absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
                </div>
              </div>

              <div className="flex items-center space-x-4">
                {/* Sort */}
                <div className="relative">
                  <select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    className="appearance-none bg-white border border-gray-300 rounded-lg px-4 py-2 pr-8 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="dueDate">Sort by Due Date</option>
                    <option value="progress">Sort by Progress</option>
                    <option value="name">Sort by Name</option>
                    <option value="priority">Sort by Priority</option>
                  </select>
                  <ChartBarIcon className="h-4 w-4 absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
                </div>
              </div>
            </div>
          </div>

          {/* Results Count */}
          <div className="px-6 py-3 bg-gray-50 border-b">
            <p className="text-sm text-gray-600">
              Showing {filteredProjects.length} of {projects.length} projects
            </p>
          </div>
        </div>

        {/* Projects Grid */}
        {filteredProjects.length === 0 ? (
          <div className="bg-white rounded-lg shadow-sm border p-12 text-center">
            <ChartBarIcon className="h-16 w-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No projects found</h3>
            <p className="text-gray-500 mb-6">
              Try adjusting your filters or search criteria to find projects.
            </p>
            <Link
              to="/projects/new"
              className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <PlusIcon className="h-4 w-4 mr-2" />
              Create New Project
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {filteredProjects.map((project) => (
              <div key={project.id} className="bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow">
                {/* Project Header */}
                <div className="p-6 border-b">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex-1">
                      <div className="flex items-center space-x-3 mb-2">
                        <Link
                          to={`/projects/${project.id}`}
                          className="text-xl font-semibold text-gray-900 hover:text-blue-600 transition-colors"
                        >
                          {project.name}
                        </Link>
                        <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getStatusColor(project.status)}`}>
                          {project.status}
                        </span>
                        <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getPriorityColor(project.priority)}`}>
                          {project.priority}
                        </span>
                      </div>
                      <p className="text-gray-600 text-sm line-clamp-2">{project.description}</p>
                    </div>
                    <div className="ml-4 flex items-center space-x-2">
                      <Link
                        to={`/projects/${project.id}/edit`}
                        className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
                      >
                        <PencilIcon className="h-4 w-4" />
                      </Link>
                      <Link
                        to={`/projects/${project.id}`}
                        className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
                      >
                        <EyeIcon className="h-4 w-4" />
                      </Link>
                    </div>
                  </div>

                  {/* Progress Bar */}
                  <div className="mb-4">
                    <div className="flex items-center justify-between text-sm text-gray-600 mb-2">
                      <span>Progress</span>
                      <span>{project.progress.toFixed(1)}%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                        style={{ width: `${project.progress}%` }}
                      ></div>
                    </div>
                  </div>

                  {/* Project Stats */}
                  <div className="grid grid-cols-3 gap-4 text-sm">
                    <div>
                      <p className="text-gray-500">Tasks</p>
                      <p className="font-medium text-gray-900">
                        {project.completedTasks} / {project.tasksCount}
                      </p>
                    </div>
                    <div>
                      <p className="text-gray-500">Team</p>
                      <p className="font-medium text-gray-900">
                        {project.teamMembers.length} members
                      </p>
                    </div>
                    <div>
                      <p className="text-gray-500">Due Date</p>
                      <p className="font-medium text-gray-900">
                        {formatDate(project.dueDate)}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Team Members */}
                <div className="p-6 border-b">
                  <div className="flex items-center justify-between mb-3">
                    <h4 className="text-sm font-medium text-gray-900">Team Members</h4>
                    <UserGroupIcon className="h-4 w-4 text-gray-400" />
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="flex -space-x-2">
                      {project.teamMembers.slice(0, 4).map((member) => (
                        <img
                          key={member.id}
                          className="h-8 w-8 rounded-full border-2 border-white"
                          src={member.avatar}
                          alt={member.name}
                          title={`${member.name} - ${member.role}`}
                        />
                      ))}
                      {project.teamMembers.length > 4 && (
                        <div className="h-8 w-8 rounded-full border-2 border-white bg-gray-100 flex items-center justify-center">
                          <span className="text-xs font-medium text-gray-600">
                            +{project.teamMembers.length - 4}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="ml-3 flex-1">
                      <p className="text-sm text-gray-600">
                        Led by <span className="font-medium">{project.teamMembers[0].name}</span>
                      </p>
                    </div>
                  </div>
                </div>

                {/* Budget Information */}
                <div className="p-6 border-b">
                  <div className="flex items-center justify-between mb-3">
                    <h4 className="text-sm font-medium text-gray-900">Budget</h4>
                    <ChartBarIcon className="h-4 w-4 text-gray-400" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">Spent</span>
                      <span className="font-medium text-gray-900">{formatCurrency(project.spent)}</span>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">Budget</span>
                      <span className="font-medium text-gray-900">{formatCurrency(project.budget)}</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className={`h-2 rounded-full transition-all duration-300 ${
                          (project.spent / project.budget) > 0.9 ? 'bg-red-500' :
                          (project.spent / project.budget) > 0.7 ? 'bg-yellow-500' :
                          'bg-green-500'
                        }`}
                        style={{ width: `${Math.min((project.spent / project.budget) * 100, 100)}%` }}
                      ></div>
                    </div>
                  </div>
                </div>

                {/* Recent Activity */}
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="text-sm font-medium text-gray-900 mb-1">Recent Activity</h4>
                      <p className="text-sm text-gray-600">{project.recentActivity}</p>
                    </div>
                    <div className="text-xs text-gray-500">
                      {project.lastUpdated}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <Footer />
    </div>
  );
};

export default ProjectView;
